import styled from 'styled-components'

import { flexCol } from '~/shared/styles/layout'

/**
 *
 */
export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  ${flexCol}
  justify-content: center;
`
